/* eslint-disable max-lines */
/* eslint-disable max-depth */
/* eslint-disable max-statements */
/* eslint-disable complexity */
import type React from 'react';
import { useCallback, useContext } from 'react';
import ComboBoxContext from '../../ComboBoxCTX.js';

export const useOnPillsNavigation = () => {
  const {
    internalRef,
    inputValue,
    hasFocus,
    setMenuState,
    selectedOptionsRef,
    props: { applyAriaDisabled, readOnly, isMenuOpenableWithReadOnly },
  } = useContext(ComboBoxContext);

  // todo: constant must be defined on pills component
  const REMOVABLE_PILL_SELECTOR = '.ds-pill-wrapper-removable button';

  const onKeyDownPills: React.KeyboardEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      if (applyAriaDisabled || (readOnly && !isMenuOpenableWithReadOnly)) {
        return;
      }
      if (
        (e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'ArrowUp' || e.key === 'ArrowDown') &&
        inputValue === ''
      ) {
        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
          internalRef.current?.focus();
          setMenuState(true, 'open', e);
          return;
        }
        if (e.key === 'ArrowLeft') {
          const removablePills: NodeListOf<HTMLButtonElement> | undefined =
            selectedOptionsRef.current?.querySelectorAll(REMOVABLE_PILL_SELECTOR);

          if (hasFocus && removablePills) {
            removablePills[removablePills.length - 1]?.focus();
          }
        }
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          internalRef.current?.focus();
        }
      }
    },
    [
      inputValue,
      internalRef,
      setMenuState,
      selectedOptionsRef,
      hasFocus,
      applyAriaDisabled,
      readOnly,
      isMenuOpenableWithReadOnly,
    ],
  );

  return { onKeyDownPills };
};
